import { Grid, Link } from "@mui/material";
import React from "react";

import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';
import ChairAltOutlinedIcon from '@mui/icons-material/ChairAltOutlined';


const DashboardMenuForDesktop = (props) => {
    const menulist = props.menuList.map(function(value, i){
        return (
            <Link href={value[1]} className={value[2] + " d-block text-left pl-3 pl-lg-5"}>
                <span class="material-icons md-10">{value[4]}</span> {value[0]} 
            </Link>
        );
    });
    return(
        <div>
            <Link href="#" className="d-block mt-2">
                <img src={props.siteLogo} className="img-fluid w-100 mb-5" style={{maxWidth: 100}} />
            </Link>
            {menulist}
        </div>
    );
}

export default DashboardMenuForDesktop;